import { createVuetify, type ThemeDefinition } from "vuetify"
import { aliases, md } from 'vuetify/iconsets/md'
import { VBtn } from 'vuetify/components/VBtn'

const lightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: "#5665FB",
    secondary: "#757575",
    tertiary: "#495057",
    accent: "#edeefe",
    error: "#fc6e6b",
    info: "#4ebcf8",
    success: "#409640",
    warning: "#ffa21a",
    application: "#EFEFEF",
  },
  variables: {
  }
}

export default createVuetify({
  theme: {
    defaultTheme: 'lightTheme',
    themes: {
      lightTheme
    }
  },
  display: {
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1800,
      xxl: 2560,
    },
  },
  aliases: {
    VBtnPrimary: VBtn,
    VBtnSecondary: VBtn,
    VBtnTertiary: VBtn,
  },
  defaults: {
    VBtnPrimary: {
      color: "primary",
      size: "x-large",
      variant: "outlined",
      rounded: 'xl',
      class: 'v-btn-primary',
    },
    VBtnSecondary: {
      color: "primary",
      size: "x-large",
      variant: "outlined",
      rounded: 'xl',
      class: 'v-btn-secondary',
    },
    VBtnTertiary: {
      color: "accent",
      size: "large",
      variant: "flat",
      rounded: 'lg',
      class: 'v-btn-tertiary',
    },
    VTextField: {
      rules: [
        (value: string) => (String(value) ? String(value).length : 0) <= 255 || 'Max 255 characters'
      ]
    },
    VCheckboxBtn: {
      falseIcon: '',
      trueIcon: 'check'
    },
    VRadioGroup: {
      falseIcon: '',
      trueIcon: 'check'
    },
  },
  date: {
    /**
     * Centralize date formats for the application.
     *
     * Formats starting with `human` are used to display to be seen by the user.
     * Non-human formats are used for inputs, vuetify components, and alike.
     *
     * @link https://momentjscom.readthedocs.io/en/latest/moment/04-displaying/01-format/
     * @link https://vuetifyjs.com/en/features/dates/#format-options
     */
    formats: {
      date: "MM/DD/YYYY",
      datetime: "MM/DD/YYYY HH:mm",
      time: "HH:mm",

      humanDate:             'MMMM D, YYYY',       // January 1, 2025 (default)
      humanDateLong:         'dddd, MMMM D, YYYY', // Monday, January 1, 2025
      humanDateAbbr:         'MMM D',              // Jan 1
      humanDateAbbrLong:     'ddd, MMM D',         // Mon, Jan 1
      humanDateAbbrYear:     'MMM D, YYYY',        // Jan 1, 2025
      humanDateAbbrYearLong: 'ddd, MMM D, YYYY',   // Mon, Jan 1, 2025
      humanDateNoYear:       'MMMM D',             // January 1
      humanDateNoYearLong:   'dddd, MMMM D',       // Monday, January 1

      humanMonth: 'MMMM YYYY', // January 2025
      humanTime:  'h:mm a',    // 1:00 pm
      humanYear:  'YYYY',      // 2025
    },
  },
  icons: {
    defaultSet: "md",
    aliases,
    sets: {
      md,
    },
  }
})
